module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_07_beach-photo-680cf4f0cdc25a82c0f868e41aaedcf4.jpg";